import React, { useState } from "react";
import { Loader2, Tag, X } from "lucide-react";
import { useCart } from "../context/CartContext";
import { formatINR } from "../api";

export const PromoCodeField = ({ id }) => {
  const { promo, promoDiscount, promoError, applyPromo, removePromo } = useCart();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const onApply = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    if (await applyPromo(code.trim())) setCode("");
    setBusy(false);
  };

  if (promo) {
    return (
      <div data-testid={`${id}-promo-applied`} className="flex items-center justify-between border border-[var(--copper)]/40 bg-white/60 px-3 h-11 text-sm">
        <span className="flex items-center gap-2 text-[var(--copper)]">
          <Tag className="w-3.5 h-3.5" /> {promo.code} applied · −{formatINR(promoDiscount)}
        </span>
        <button type="button" onClick={removePromo} data-testid={`${id}-promo-remove`} aria-label="Remove promo code" className="p-1 hover:text-[var(--copper)]">
          <X className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={onApply} data-testid={`${id}-promo-form`}>
      <label className="text-[10px] tracking-[0.2em] uppercase text-[var(--espresso)]/60">Apply promo code</label>
      <div className="mt-2 flex">
        <input
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="Enter code"
          data-testid={`${id}-promo-input`}
          className="flex-1 min-w-0 h-11 px-3 border border-[var(--sand)] bg-transparent text-sm uppercase tracking-wider focus:outline-none focus:border-[var(--copper)]"
        />
        <button type="submit" disabled={busy || !code.trim()} data-testid={`${id}-promo-apply`} className="h-11 px-5 bg-[var(--espresso)] text-[var(--cream)] text-[10px] tracking-[0.2em] uppercase disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Apply"}
        </button>
      </div>
      {promoError && <p data-testid={`${id}-promo-error`} className="mt-2 text-xs text-red-700">{promoError}</p>}
    </form>
  );
};

export const PromoDiscountRow = ({ id }) => {
  const { promo, promoDiscount } = useCart();
  if (!promo) return null;
  return (
    <div className="flex justify-between text-[var(--copper)]" data-testid={`${id}-promo-row`}>
      <span>Promo code {promo.code}</span><span>−{formatINR(promoDiscount)}</span>
    </div>
  );
};
